import { Transition } from "motion";

export class HopAnimation {
    getAnimation() {
        return {
            animate: {
                opacity: 1,
                scale: 1,
                y: [0, -6, 0, -3, 0],
            },
            transition: {
                duration: 1.2,
                repeat: Infinity,
                repeatType: "loop",
                ease: "easeInOut",
            } as Transition
        };
    }
}
